import React from 'react';

import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import LoadingPlaceholder from 'components/loadingPlaceholder';
import useResultProvider from 'dataProvider/hooks/useResultProvider';
import { getSite } from 'constants/sites';
import { TYPES, SUBTYPES } from '../../envs';
import TableRanking from '../../components/tableRanking';

import './rankingTable.scss';

const RankingTable = () => {
  const { matchParams } = useContextMatchParams();
  const { year, type, electionNumber, placeId } = matchParams;

  const resultOrigin = useContextResultOrigin();

  const site = getSite();

  const { result: dataResult } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.primary?.active,
    year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber,
    placeId,
    site
  });

  const { result: oldData } = useResultProvider({
    electionPlace: placeId,
    active: resultOrigin?.historic?.active,
    year: resultOrigin?.historic?.year,
    type,
    subtype: type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
    electionNumber: resultOrigin?.historic?.numElection,
    placeId,
    site
  });

  if (!dataResult || !oldData) {
    return <LoadingPlaceholder />;
  }

  return (
    <div className="rankingTablePage">
      {/* <CintilloComunidad title="PACTÓMETRO">
        {' '}
        <span className="subtitle">Escaños</span>
      </CintilloComunidad> */}
      {/* TODO: Revisar Cintillo ------ Escaños */}
      <div className="rankingPactometroWrapper">
        <div className="rankingWrapper">
          <TableRanking
            currentData={dataResult}
            pastData={oldData}
            year={year}
            electionNumber={electionNumber}
            electionType={type}
            placeId={placeId}
            titleColumn={dataResult.year}
            titleColumn2={oldData.year}
          />
        </div>
      </div>
    </div>
  );
};

export default RankingTable;
